// utils/offersClient.js
export async function previewOffer(idToken, baseUrl, { coupon, utm }) {
  const res = await fetch(`${baseUrl}/api/offers/preview`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${idToken}` },
    body: JSON.stringify({ coupon, utm })
  });
  if (!res.ok) return { offer: null };
  return res.json();
}

export async function redeemOffer(idToken, baseUrl, { offerId, coupon, utm }) {
  const res = await fetch(`${baseUrl}/api/offers/redeem`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${idToken}` },
    body: JSON.stringify({ offerId, coupon, utm })
  });
  return res.json();
}
